// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const kratorplusColors: ColorType = { ...colorPalette, primary: '#9841A6', secondary: '#9841A6' }

export const lightTheme = {
  colors: kratorplusColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: kratorplusColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: kratorplusColors.dark,
    secondary: kratorplusColors.grayText,
    disabled: kratorplusColors.dark,
    link: kratorplusColors.dark,
    hint: kratorplusColors.dark,
    highlight: kratorplusColors.primary,
    gray: kratorplusColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: kratorplusColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: kratorplusColors.dark,
    color: kratorplusColors.dark,
    border: kratorplusColors.primary,
    scrollbarThumb: kratorplusColors.primary,
    programTitle: kratorplusColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: kratorplusColors.dark,
        selected: kratorplusColors.dark,
        progress: rgba(kratorplusColors.primary, 0.3),
        past: rgba(kratorplusColors.primary, 0.3),
        pastSelected: kratorplusColors.dark,
        pastHover: kratorplusColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(kratorplusColors.primary, 0.1),
      },
      text: {
        empty: kratorplusColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: kratorplusColors.dark,
    subTitle: kratorplusColors.grayText,
    bg: kratorplusColors.dark,
    number: kratorplusColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 158,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
